import 'jquery';
import 'bootstrap';
// import './tinyslider';
import './block-videos';
import './print-form-summary';
import './cta-block-equal-height';
import './docknav-height';
import './live-chat-popup';
import './tabs-deep-link';
import './jquery.fancybox3.min.js';
import './rebelware-middleware-utm-tracking';
import './sidebar';

document.addEventListener('DOMContentLoaded', function() {
    let ondemand_events = document.querySelectorAll('.cat_on-demand');

    ondemand_events.forEach(function(_event) {
        let event_wrapper = _event.closest('.tribe-events-calendar-list__event-row');
      
        if(event_wrapper){
          let large_date = event_wrapper.querySelector('.tribe-events-calendar-list__event-date-tag-datetime');
          let small_date = event_wrapper.querySelector('time.tribe-events-calendar-list__event-datetime');

          large_date.style.opacity = 0;
          small_date.style.opacity = 0;
        }

        let single_event = _event.closest(".single-content");
        if(single_event){
          let single_event_date = single_event.querySelector('.tribe-events-schedule');
          single_event_date.style.opacity = 0;
        }
        
    })
});

// import simpleParallax from 'simple-parallax-js';

let fancy_inline_links = $('a[href*="youtube"], a[href*="vimeo"], a[href*=".pdf"]:not([download])');
  //console.log(fancy_inline_links, "links");
  if(fancy_inline_links.length > 0 && window.outerWidth > 640){
    fancy_inline_links.each(function(k, link){
      $(link).attr("data-fancybox","link");
    });
  }


$(document).on("click", ".mega-menu .mega-sub-menu .mega-sub-menu .mega-menu-item-has-children > .mega-menu-link", function(e){
  e.preventDefault();
  let ele = $(this);
  ele.next().toggleClass("show");  
});

$(window).on("load", function(){
  if($(".gform_validation_errors").length > 0){
    $('html,body').animate({
      scrollTop: $(".gform_validation_errors").offset().top - 50
    });
  }

  $('.simple-banner').attr("role", "banner");

  $('#simple-banner-close-button').on("click",function(){
    $('.block-hero').css("margin-top", $(".banner").outerHeight() + "px");
  });

});

function check_consent() {
  let checkboxes = document.querySelectorAll(".ginput_container_consent input");
  checkboxes.forEach(function(check){
    check.setAttribute('checked', true);
  })
}

function add_3rd_tier_pages_to_desktop_nav(){
  let suspect_pages = document.querySelectorAll(".mega-menu .mega-sub-menu .mega-sub-menu .mega-menu-item-has-children > .mega-menu-link");
  suspect_pages.forEach(function(page){

    let text = page.innerHTML;
    let href = page.getAttribute('href');
    let dropdown = page.nextElementSibling;

    dropdown.innerHTML = '<li class="d-none d-lg-block mega-menu-item mega-menu-item-type-post_type mega-menu-item-object-page"><a class="mega-menu-link" href="' + href + '">' + text + '</a></li>' + dropdown.innerHTML;
  });
}

function set_focus_on_summary(){
  let summary = document.querySelector('#Summary button');
  if(summary){
    summary.focus();
  }
}

$(function(){

  let items = $('[data-fancybox^="gallery"]');
  // console.log(items,"fanc items");

  $('[data-fancybox^="gallery"]').fancybox({
    thumbs : {
      autoStart   : true,
      hideOnClose : true
    }
  });

  add_3rd_tier_pages_to_desktop_nav();
  check_consent();
  check_banner();
  set_focus_on_summary();

   let modals = $('.video-modal');
   modals.each(function(k,v){
    $(v).on("hidden.bs.modal", function(){
      // console.log("hidden bs:")
      let iframe = $(v).find("iframe");
      let temp = iframe.attr("src");

      iframe.attr("src",  ""); 
      setTimeout(function(){
        iframe.attr("src", temp);
      },100)
    })
   });




  
  let search_input = document.querySelector("input#search");
  if(search_input){
    window.onload = function() {
      var input = search_input.focus();
    }
  }
    
 
  if($('.carousel').length > 0){
    $('.carousel').carousel();
  }
});

// Detect whether the user is running IE11
var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

// // Passive event listeners
// jQuery.event.special.touchstart = {
//   setup: function( _, ns, handle ) {
//       this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
//   }
// };

// jQuery.event.special.touchmove = {
//   setup: function( _, ns, handle ) {
//       this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
//   }
// }; 

function is_touch_device() {
  return !!('ontouchstart' in window);
}

$(document).ready(() => {


  /**
   * Parallax images in feature blocks
   */
  // if(!isIE11 && window.innerWidth > 640 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  //   var ParallaxBlocks = document.querySelectorAll('.is-style-parallax');
  //   // console.log(ParallaxBlocks, "parallax blocks");

  //   ParallaxBlocks.forEach((block) => {
  //     // console.log(block.dataset,"block");
  //     new simpleParallax(block.querySelector('.parallax-img'), {
  //       overflow: (block.dataset.overflow !== undefined) ? block.dataset.overflow : true,
  //       scale: (block.dataset.scale !== undefined) ? block.dataset.scale : 2,
  //       orientation: (block.dataset.orientation !== undefined) ? block.dataset.orientation : "up",
  //       delay: 0,
  //       maxTransition: (block.dataset.maxTransition !== undefined) ? block.dataset.maxTransition : "100%"
  //     });
  //   });
  // }

  // Hamburger Menu
  $('.hamburger').click(function() {
    $(this).toggleClass('is-active');
  });

  //Location page collapse


  if ($(window).width() < 700) {
    $('.mobilecollapse').addClass('collapse');
  }
  $('.mobiletoggleButton').click(function() {
    if ($(this).hasClass("collapsed")) {
      $(this).addClass('mobileminusPlus');
      $(this).removeClass('mobileplusMinus');
    }
    else {
      $(this).addClass('mobileplusMinus');
      $(this).removeClass('mainminusPlus');
    }
  });
  $('.maintoggleButton').click(function() {
    if ($(this).hasClass("collapsed")) {
      $(this).addClass('mainminusPlus');
      $(this).removeClass('mainplusMinus');
    }
    else {
      $(this).addClass('mainplusMinus');
      $(this).removeClass('mainminusPlus');
    }
  });

  $('.faqToggle').click(function() {
    if ($(this).hasClass("collapsed")) {
      $(this).addClass('minusPlus');
      $(this).removeClass('plusMinus');
      $(this).removeClass('collapsed');
    }
    else {
      $(this).addClass('plusMinus');
      $(this).removeClass('minusPlus');
      $(this).addClass('collapsed');
    }
  });

});

function check_banner(){
  let simple_banner = document.getElementById('simple-banner');
  // console.log(simple_banner, "banner");
  if(!simple_banner){
    let hero = document.querySelector("#hero")
    if(hero){
      hero.classList.add("banner-check");
    }
  }
}

function isInViewObserverInit(e) {

  var options = {
    root: null,
    rootMargin: '20px',
    threshold: [0, 0.1, 0.20, 0.30, 0.40, 0.5, 0.60, 0.70, 0.80, 0.9, 1]
 }

  if ("IntersectionObserver" in window) {

      let inView = new IntersectionObserver(function (e, n) {
          e.forEach(function (e) {
              if (e.isIntersecting) {
                // console.log(e);
                let n = e.target;
                n.dataset.iRatio = e.intersectionRatio;
                if (n.dataset.isInViewWatcher !== '') {
                  if (e.intersectionRatio >= n.dataset.isInViewWatcher) {
                    n.classList.add("isInView");
                    // console.log("is In view: " + e.intersectionRatio + " >= " + n.dataset.isInViewWatcher)
                    inView.unobserve(n);
                  }
                } else {
                  n.classList.add("isInView");
                  inView.unobserve(n);
                }
            }
          })
      }, options);

      e.forEach(function (e) {
        inView.observe(e)
      })
  } else {
    e.forEach(function (e) {
      let n = e.target;
      n.classList.add("isInView");
    });
  }
}

document.addEventListener("DOMContentLoaded", function () {
  var e = [].slice.call(document.querySelectorAll("[data-is-in-view-watcher]"));
  isInViewObserverInit(e);
});

$(function(){

  // $('.collapse').on('hidden.bs.collapse', function () {
  //   if(jQuery('.block-featuredfaq .collapse.show').length == 0){
  //     $(this).collapse('show');
  //   }
  // });

  $(window).on("scroll",function(e){
    e.stopPropagation();
    if(window.pageYOffset >= 1500){
      $('.back2top').addClass("show");
    } else {
      $('.back2top').removeClass("show");
    }

  });

  $('.back2top').on("click",function(e){
    e.preventDefault();
    e.stopPropagation();
    $("html, body").animate({ scrollTop: 0 }, 500);
    $(this).addClass("is-active");
  });

});

  var phone = "()-+. 0123456789"
  var numb = "0123456789"
  var zip = "0123456789-"
  var alpha = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ 0123456789";

  function res(t, v) {
      var w = ""
      var i, x = 0;
      for (i = 0; i < t.value.length; i++) {
          x = t.value.charAt(i);
          if (v.indexOf(x, 0) != -1)
              w += x;
      }
      t.value = w;
  }

  let zip_fields = document.querySelectorAll('[autocomplete="postal-code"]');
  zip_fields.forEach(function(_zip){
    _zip.addEventListener('keyup', function(event){
      res(event.target,zip)
    });
  })
